import { render, staticRenderFns } from "./EntryPoint.vue?vue&type=template&id=21b70d4a"
import script from "./EntryPoint.vue?vue&type=script&lang=js"
export * from "./EntryPoint.vue?vue&type=script&lang=js"
import style0 from "./EntryPoint.vue?vue&type=style&index=0&id=21b70d4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports